import { render, staticRenderFns } from "./EmailSidepanel.vue?vue&type=template&id=2234ac40&"
import script from "./EmailSidepanel.vue?vue&type=script&lang=js&"
export * from "./EmailSidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports